import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Table from 'react-bootstrap/Table';
import Skeleton from 'react-loading-skeleton'
//import { Document, Page, pdfjs } from 'react-pdf'
//import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import axios from 'axios';
import ConfirmPopup from './../modal/modal';
import FormFileUpload from "./../inputs/fileupload";
import FormSelect from './../inputs/select';
import ManagementTable from "./../tables/managementTable";
import FormAutoComplete from './../inputs/autocomplete';

import { saveAs } from 'file-saver';
import { getUserType, currentUserId, getUserTypes, getYesNoOptions, setConfig, getConfig, getYesNo } from './../../utils';
import cloneDeep from 'lodash/cloneDeep';

const UserDocumentsAdmin = (props) => {
    /*useEffect(() => {
        pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    });*/

    //const [show, setShow] = useState(false);
    /*const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);*/

    const pdfs = ["https://cdn.filestackcontent.com/wcrjf9qPTCKXV3hMXDwK", "https://owasp.org/www-pdf-archive/GOD17-CORS.pdf", "https://www.entnet.org/wp-content/uploads/2021/04/Instructions-for-Adding-Your-Logo-2.pdf"]
    const [page, setPage] = useState(1);    
    const [file, setFile] = useState("");
    const skeletonCount = 5;
    const [numPages, setNumPages] = useState(0); 
    /*httpHeaders: {
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NzU3MDM5MjIsImlzcyI6IlNhcERldmVsb3BlcnNBdXRoIiwiYXVkIjoiU2FwRGV2ZWxvcGVyc0F1dGgiLCJ1c3IiOjEsInJvbCI6MX0.2XhELbb_r8HIHYjRYRVQDwAAV8Zk6hJNZKUUCicRp78gL__bKVUzofYGTUiE8JZdHGof3RY_RVO7VC4kAKqsVA'
        }*/
    let navigate = useNavigate();
    const { usersAdminStore, loginStore, invoiceStore, activitiesStore, fileStore}= useStores();
    //const { getDummy, users, user, dummies } = usersAdminStore;
    const { getDummy,getAllUsers, users, searchConsultant } = usersAdminStore;
    const { search, activities } = activitiesStore;
    const { upload, getAllWithOptions, documents, deleteDocument, getDocumentFile} = fileStore;
    const { sendViaEmail } = invoiceStore;
    const { t, i18n } = useTranslation();    
    const {  accountInfo } = loginStore;
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const [isSendingMail, setSendingMail] = useState(false);
    const [validated, setValidated] = useState(false);
    const [modalSettings, setModalSettings] = useState({});
    const [showValidateConfirm, setShowValidateConfirm] = useState(false);
    const tableRef = useRef(null);

    const openRandomPdf = () => {
        var min = 0;
        var max = pdfs.length - 1;
        let rand = Math.floor(Math.random() * (max - min + 1)) + min;
        setFile("https://localhost:7231/api/invoices/report");
        setPage(1)
    }

    const openPdf = (id) => {        
        setFile(`${axios.defaults.baseURL}api/invoices/report/${id}`);
        setPage(1)
    }

    const onPageChange = (props) => {
        var newProps = cloneDeep(props);        
        setIsLoading(true);
        getAllWithOptions(newProps/*props.page + 1, props.filter, props.sort*/).then(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        setIsLoading(true);
        Promise.all([getDummy(),search()]).then(() => setIsLoading(false));
    }, [getDummy]);


    const handleUpload = (event) => {
        
        event.preventDefault();
        const form = event.currentTarget;
        
        if (form.checkValidity() === false) {            
            event.preventDefault();
            event.stopPropagation();
        } else {                        
            const formData = Object.fromEntries(new FormData(event.target).entries());                        
            var files = new FormData(event.target)?.getAll("file") ?? [];
            
            var data = new FormData();

            if (files && files?.length) {
                files?.forEach((f, i) => {
                    data.append(`file`, files[i])
                })
            }
            //data.append("file", formData.file);
            if (accountInfo?.role != 1)
                data.append("activityId", formData.activityId);
            else
                data.append("consultantId", formData.consultantId);

            //console.log(data)
            upload(data).then(() => { setValidated(false); handleClose(); tableRef?.current?.resetPage() });
        }
        setValidated(true);
    };

    const downloadFile = (id) => {
        var file = documents?.results?.find(x => x.id == id);
        if (file) 
            getDocumentFile(id).then((b) => saveAs(new Blob([b.bytes]), file.filename))
    }

    return (
        <div>
            <Modal show={show} onHide={() => { setValidated(false); handleClose() }}>
                    <Form noValidate validated={validated} onSubmit={handleUpload}>
                        <Modal.Header closeButton>
                            <Modal.Title>{t("uploadDocument")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Stack gap={2}>
                            <FormFileUpload multiple required label={t("files")} id="file" isLoading={isLoading} innerText={t("noFiles")} accept=".pdf" />
                                {accountInfo?.role != 1 &&
                                    <FormSelect required label={`${t("relatedActivity")}:`} id="activityId" isLoading={isLoading} itemId="id" itemLabel="name" items={activities} />
                                }
                                {accountInfo?.role == 1 &&
                                    <FormAutoComplete service={searchConsultant} itemFn={(option) => `${option.name} ${option.surname} (${option.username} - ID: ${option.id})`} validated={validated} required label={t("consultant")} id="consultant" formId="consultantId" isLoading={isLoading} />
                                }
                            </Stack>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" type="submit" /*onClick={() => { alert("dsa") }}*/>
                                {t("uploadDocument")}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                <ConfirmPopup show={showValidateConfirm} isDeleting={false} onClose={() => setShowValidateConfirm(false)} title={modalSettings?.title} body={modalSettings?.body} onClick={modalSettings.onConfirm} />

            <ManagementTable name={t('documents')} ref={tableRef} isLoading={isLoading}
                new={{ title: "uploadDocument", onClick: () => { setShow(true) }, hidden: accountInfo?.role != 1 }}

                onColumnSizeChange={(c) => setConfig("documents", "size", c)}
                onDataStateChange={(c) => { setConfig("documents", "dataState", c) }}
                onFiltersChange={(c) => {/* setConfig("filter", c) */ }}
                config={{ size: getConfig("documents", "size"), dataState: getConfig("documents", "dataState") }}                
                items={documents?.results} onPageChange={onPageChange} pageCount={documents?.pageCount} total={documents?.count} pageSize={documents?.pageSize}
                columns={
                    accountInfo.role == 1 ?
                        [
                            { name: "filename", size: 230 },                        
                            { name: "for", prop: "to", fn: (v) => v ? `${v?.username}` : "-" },
                        ]
                        :
                        [
                            { name: "filename", size: 230 },
                        ]
                }
                extraButtons=
                {
                    accountInfo.role == 1 ?
                        [                            
                            { text: t('download'), icon: solid("download"), onClick: (id) => { downloadFile(id) /*    console.log(documents?.results?.find(x=>x.id==id))*/ }, /*modalText: t("confirmDelete"), modalTitle: t("delete")*/ },
                            { text: t('delete'), icon: solid("trash"), onClick: (id) => { deleteDocument(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmDelete"), modalTitle: t("delete"), danger: true },
                        ]
                        :
                        [
                            { text: t('download'), icon: solid("download"), onClick: (id) => { downloadFile(id); }, /*modalText: t("confirmDelete"), modalTitle: t("delete")*/ }
                        ]
                }
                />

            </div>

    );
};

export default observer(UserDocumentsAdmin);
